import { Flex, Text, useColorModeValue, useToken, Box } from '@chakra-ui/react'
import { format } from 'date-fns'

type DefaultDayProps = {
  calendarWith6LinesOfDays?: boolean
  _isSameMonth: boolean
  _isInThePeriod: boolean
  _isToday: boolean
  day: Date
}

export default function DayComponent({ calendarWith6LinesOfDays, _isSameMonth, _isInThePeriod, _isToday, day }: DefaultDayProps) {
  const [primary300, primary500] = useToken('colors', ['primary.300', 'primary.500'])

  const bgOfOtherMonths = useColorModeValue('gray.200', 'gray.700')
  const textColor = useColorModeValue('gray.700', 'gray.200')
  const shadowColor = useColorModeValue(primary500, primary300)

  return (
    <Flex
      border="1px solid"
      borderColor="borderColor"
      h={calendarWith6LinesOfDays ? '50px' : '60px'}
      w="full"
      opacity={_isSameMonth ? 1 : 0.7}
      bg={_isSameMonth ? 'light' : bgOfOtherMonths}
      boxShadow={_isInThePeriod ? `inset 0px 0px 0px 1px ${shadowColor}` : 'none'}
    >
      <Flex p={1} w="full" justify="center">
        <Flex
          bg={_isToday ? 'primary.500' : 'none'}
          color={_isToday ? 'white' : textColor}
          h="5"
          w="5"
          justifyContent="center"
          alignItems="center"
          borderRadius="full"
        >
          <Text lineHeight="50%" fontSize="xs">
            {format(new Date(day), 'dd')}
          </Text>
        </Flex>
      </Flex>
      <Box></Box>
    </Flex>
  )
}
